import * as React from 'react';
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { logout } from "../../../redux/actions/userActions";
import { useDispatch } from "react-redux";
import { Link as LinkReact } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import AdbIcon from '@mui/icons-material/Adb';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import AdminConfigsElementCard from "./AdminConfigsElementCard.js";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const config = require("../../../constants/constants.js")

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AdminConfigsPageComponent = ({
  fetchOrdersForFirstDate,
  fetchOrdersForSecondDate,
  socketIOClient
}) => {

  const navigate = useNavigate();

  const [firstDateToCompare, setFirstDateToCompare] = useState(
    new Date().toISOString().substring(0, 10)
  );
  var previousDay = new Date();
  previousDay.setDate(previousDay.getDate() - 1);

  const [page, setPage] = useState({});

  const getPagesApiRequest = async () => {
    const url = `/api/pages`;
    const { data } = await axios.get(url);
    console.log("data=", data)
    return data
  }

  const [tabAttivo, setTabAttivo] = React.useState('home');

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  const theme = useTheme();

  const handleChange = (event, newValue) => {
    console.log('[handleChange] TAB newValue=', newValue);
    if (newValue === 0) {
      readPageByMenuValue('HOME');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(0));
    }
    if (newValue === 1) {
      readPageByMenuValue('STAFF');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(1));
    }
    if (newValue === 2) {
      readPageByMenuValue('AREE COMPETENZA');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(2));
    }
    if (newValue === 3) {
      readPageByMenuValue('CHI SIAMO');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(3));
    }
    if (newValue === 4) {
      readPageByMenuValue('CONTATTI');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(4));
    }
    if (newValue === 5) {
      readPageByMenuValue('LOGIN');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(5));
    }
    if (newValue === 6) {
      readPageByMenuValue('ACCOUNT');
      window.sessionStorage.setItem('configTabActive', JSON.stringify(6));
    }
    if (newValue === 7) {
      window.sessionStorage.setItem('configTabActive', JSON.stringify(7));
    }
    if (newValue === 8) {
      window.sessionStorage.setItem('configTabActive', JSON.stringify(8));
    }
    setValue(newValue);
  };

  const [menuValue, setmenuValue] = useState("");
  const [menuLevel, setMenuLevel] = useState(0);
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedContent, setCustomizedContent] = useState([]);
  const [titleImg1, setTitleImg1] = useState("");
  const [subTitleImg1, setSubTitleImg1] = useState("");
  const [titleImg2, setTitleImg2] = useState("");
  const [subTitleImg2, setSubTitleImg2] = useState("");
  const [titleImg3, setTitleImg3] = useState("");
  const [subTitleImg3, setSubTitleImg3] = useState("");

  const [pageImageItems, setPageImageItems] = useState([]);

  const [idConfig, setIdConfig] = useState("");
  const [siteStyle, setSiteStyle] = useState("");
  const [isServiceActive, setIsServiceActive] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");
  const [menuSequence, setMenuSequence] = useState([]);
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [cliente, setCliente] = useState("");
  const [partitaIva, setPartitaIva] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [cap, setCap] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [telefono, setTelefono] = useState("");
  const [telefono1, setTelefono1] = useState("");
  const [telefono2, setTelefono2] = useState("");
  const [telefono3, setTelefono3] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobile1, setMobile1] = useState("");
  const [mobile2, setMobile2] = useState("");
  const [mobile3, setMobile3] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [email3, setEmail3] = useState("");
  const [imageLogo, setImageLogo] = useState("");
  const [aliquotaIva, setAliquotaIva] = useState(0);
  const [aliquotaIvaRid, setAliquotaIvaRid] = useState(0);
  const [aliquotaIvaMin, setAliquotaIvaMin] = useState(0);
  const [aliquotaIva1, setAliquotaIva1] = useState(0);
  const [aliquotaIva2, setAliquotaIva2] = useState(0);
  const [aliquotaIva3, setAliquotaIva3] = useState(0);
  const [customerCode, setCustomerCode] = useState("");
  const [titleProduct, setTitleProduct] = useState("");
  const [siteStyleActive, setSiteStyleActive] = useState("");
  const [enableSwitchStyle, setEnableSwitchStyle] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");

  const [styleActive, setStyleActive] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);


  const [updatePageResponseState, setUpdatePageResponseState] = useState({
    message: "",
    error: "",
  });

  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldLastnameError, setFieldLastnameError] = useState(false);
  const [fieldEmailError, setEmailFieldError] = useState(false);
  const [fieldPasswordError, setFieldPasswordError] = useState(false);

  const handleSalva = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget.elements;

    console.log('[handleSalva] id-Page=', id);
    console.log('[handleSalva] page=', page);
    console.log('[handleSalva] form=', form);
    console.log('[handleSalva] title=', title);
    console.log('[handleSalva] subTitle=', subTitle);
    console.log('[handleSalva] description=', description);
    console.log('[handleSalva] pageImageItems=', pageImageItems);

    if (value === 0 || value === 1 || value === 2 || value === 3 || value === 4 || value === 5) {

    const formInputs = {
      title: title,
      subTitle: subTitle,
      description: description,
      images: pageImageItems,
    };

    console.log('[handleSalva] valueTab =', value);
    console.log('[handleSalva] formInputs =', formInputs);

    if (event.currentTarget.checkValidity() === true) {
      console.log('[handleSalva] updatePageApiRequest =', event.currentTarget.checkValidity());
      updatePageApiRequest(id, formInputs)
        .then((data) => {
          if (data.message === "page updated") navigate("/admin/configs");
        })
        .catch((er) =>
          setUpdatePageResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          })
        );
      }
    }
    if (value === 6 || value === 7 || value === 8) {
      const formInputs = {
        title: form.title.value,
        subTitle: form.subTitle.value,
        titleImg1: form.titleImg1.value,
        subTitleImg1: form.subTitleImg1.value,
        titleImg2: form.titleImg2.value,
        subTitleImg2: form.subTitleImg2.value,
        titleImg3: form.titleImg3.value,
        subTitleImg3: form.subTitleImg3.value,
      };

      console.log('[handleSalva] formInputs =', formInputs);

      if (event.currentTarget.checkValidity() === true) {
        updatePageApiRequest(id, formInputs)
          .then((data) => {
            if (data.message === "page updated") navigate("/admin/configs");
          })
          .catch((er) =>
            setUpdatePageResponseState({
              error: er.response.data.message
                ? er.response.data.message
                : er.response.data,
            })
          );
      }
    }
    if (value === 9) {

      let styleWeb = ' ';
      if (siteStyleActive === 'Classic') styleWeb = 'A';
      if (siteStyleActive === 'Jazz') styleWeb = 'B';
      if (siteStyleActive === 'Modern') styleWeb = 'C';
      if (siteStyleActive === 'Time') styleWeb = 'D';
      console.log('[handleSalva] styleWeb =', styleWeb);

      const formInputsConfig = {
        siteStyleActive: styleWeb,
        ragioneSociale: form.ragioneSociale.value,
        cliente: form.cliente.value,
        partitaIva: form.partitaIva.value,
        indirizzo: form.indirizzo.value,
        cap: form.cap.value,
        citta: form.citta.value,
        provincia: form.provincia.value,
        telefono: form.telefono.value,
        telefono1: form.telefono1.value,
        //telefono2: form.telefono2.value,
        //telefono3: form.telefono3.value,
        mobile: form.mobile.value,
        mobile1: form.mobile1.value,
        //mobile2: form.mobile2.value,
        //mobile3: form.mobile3.value,
        email: form.email.value,
        email1: form.email1.value,
        //email2: form.email2.value,
        //email3: form.email3.value,
        //imageLogo: form.imageLogo.value,
        aliquotaIva: form.aliquotaIva.value,
        aliquotaIvaRid: form.aliquotaIvaRid.value,
        aliquotaIvaMin: form.aliquotaIvaMin.value,
        //aliquotaIva1: form.aliquotaIva1.value,
        //aliquotaIva2: form.aliquotaIva2.value,
        //aliquotaIva3: form.aliquotaIva3.value,
        //customerCode: form.customerCode.value,
        //titleProduct: form.titleProduct.value,
        //siteStyleActive: form.siteStyleActive.value,
        //enableSwitchStyle: form.enableSwitchStyle.value,
        //urlSiteImageServer: form.urlSiteImageServer.value,
        //urlCustomerImageServer: form.urlCustomerImageServer.value,
      };

      console.log('[handleSalva] formInputsConfig =', formInputsConfig);

      if (event.currentTarget.checkValidity() === true) {
        updateConfigApiRequest(idConfig, formInputsConfig)
          .then((data) => {
            if (data.message === "page updated") navigate("/admin/configs");
          })
          .catch((er) =>
            setUpdatePageResponseState({
              error: er.response.data.message
                ? er.response.data.message
                : er.response.data,
            })
          );
      }

    }

    setValidated(true);

    window.location.assign('/admin/configs')
  };

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/products')
  }

  const [validated, setValidated] = useState(false);

  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);

  // TAB active
  const [cookieTabActive, setCookieTabActive] = useState("");
  const [value, setValue] = useState();

  const uploadImagesApiRequest = async (images, pageId) => {

    console.log("[uploadImagesApiRequest]")
    console.log("[uploadImagesApiRequest] images=", images)
    console.log("[uploadImagesApiRequest] id=", pageId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });
    const { data } = await axios.post("/api/pages/admin/upload?pageId=" + pageId, formData);
    return data;
  };

  const [product, setProduct] = useState({});

  const updatePageApiRequest = async (pageId, formInputs) => {
    const { data } = await axios.put(`/api/pages/admin/${pageId}`, { ...formInputs });
    return data;
  }

  const updateConfigApiRequest = async (configId, formInputs) => {
    const { data } = await axios.put(`/api/configs/admin/${configId}`, { ...formInputs });
    return data;
  }

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    return data
  }

  const readPageByMenuValue = (titleString) => {
    console.log("[readPageByMenuValue} page con menuValue =", titleString);
    getPageByMenuValueApiRequest(titleString).then((data) => {
      //console.log(`data =`, data);
      setPage(data)
      //console.log(`page =`, page);
      setPageImageItems(data?.images);
      //console.log(`pageImageItems =`, pageImageItems);

      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id)
      setTitleImg1(data?.imagesTitle[0].text);
      setSubTitleImg1(data?.imagesSubTitle[0].text);
      setTitleImg2(data?.imagesTitle[1].text);
      setSubTitleImg2(data?.imagesSubTitle[1].text);
      setTitleImg3(data?.imagesTitle[2].text);
      setSubTitleImg3(data?.imagesSubTitle[2].text);
    })
      .catch((er) => {
        console.log(er);
      });
  }

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  // ---------------------  useEffect INI

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      console.log(`data =`, data);
      setIdConfig(data?._id);
      setSiteStyle(data?.siteStyle)
      setIsServiceActive(data?.isServiceActive)
      setIsShopActive(data?.isShopActive)
      setIsIconLoginActive(data?.isIconLoginActive)
      setMenuSequence(data?.menuSequence)
      setRagioneSociale(data?.ragioneSociale);
      setCliente(data?.cliente);
      setPartitaIva(data?.partitaIva);
      setIndirizzo(data?.indirizzo);
      setCap(data?.cap);
      setCitta(data?.citta);
      setProvincia(data?.provincia);
      setTelefono(data?.telefono);
      setTelefono1(data?.telefono1);
      setTelefono2(data?.telefono2);
      setTelefono3(data?.telefono3);
      setMobile(data?.mobile);
      setMobile1(data?.mobile1);
      setMobile2(data?.mobile2);
      setMobile3(data?.mobile3);
      setEmail(data?.email);
      setEmail1(data?.email1);
      setEmail2(data?.email2);
      setEmail3(data?.email3);
      setImageLogo(data?.imageLogo);
      setAliquotaIva(data?.aliquotaIva);
      setAliquotaIvaRid(data?.aliquotaIvaRid);
      setAliquotaIvaMin(data?.aliquotaIvaMin);
      setAliquotaIva1(data?.aliquotaIva1);
      setAliquotaIva2(data?.aliquotaIva2);
      setAliquotaIva3(data?.aliquotaIva3);
      setCustomerCode(data?.customerCode);
      setTitleProduct(data?.titleProduct);
      //setSiteStyleActive(data?.siteStyleActive);
      if (data?.siteStyleActive === 'A') setSiteStyleActive('Classic');
      if (data?.siteStyleActive === 'B') setSiteStyleActive('Jazz');
      if (data?.siteStyleActive === 'C') setSiteStyleActive('Modern');
      if (data?.siteStyleActive === 'D') setSiteStyleActive('Time');
      setEnableSwitchStyle(data?.enableSwitchStyle);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      console.log(`ragioneSociale =`, data?.ragioneSociale);
      console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])


  // TAB active

  useEffect(() => {
    setCookieTabActive(window.sessionStorage.getItem('configTabActive'));
    if (typeof cookieTabActive === "string") {
      // già esiste
      console.log("La stringa cookieTabActive è valorizzata");
      console.log("cookieTabActive = ", cookieTabActive);
      setValue(Number(cookieTabActive))

      if (Number(cookieTabActive) === 0) {
        readPageByMenuValue('HOME');
      }
      if (Number(cookieTabActive) === 1) {
        readPageByMenuValue('STAFF');
      }
      if (Number(cookieTabActive) === 2) {
        readPageByMenuValue('AREE COMPETENZA');
      }
      if (Number(cookieTabActive) === 3) {
        readPageByMenuValue('CHI SIAMO');
      }
      if (Number(cookieTabActive) === 4) {
        readPageByMenuValue('CONTATTI');
      }
      if (Number(cookieTabActive) === 5) {
        readPageByMenuValue('LOGIN');
      }
      if (Number(cookieTabActive) === 6) {
        readPageByMenuValue('ACCOUNT');
      }
      if (Number(cookieTabActive) === 7) {
      }
      if (Number(cookieTabActive) === 8) {
      }

    } else if (cookieTabActive === null) {
        // null
        console.log("The string cookieTabActive is null");
        readPageByMenuValue('HOME');
    } else {
        // è ???
        console.log("La stringa cookieTabActive è ???");
        readPageByMenuValue('HOME');
    }
  }, [cookieTabActive]);

  // ---------------------  useEffect FIN

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("pageImageItems.images=" + pageImageItems.images)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setIsUploading("upload files in corso ...");
    if (process.env.NODE_ENV !== "production") {
      uploadImagesApiRequest(event.target.files, id)
        .then(data => {
          setIsUploading("upload files completato");
          setImageUploaded(!imageUploaded);
        })
        .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    } else {
      uploadImagesApiRequest(event.target.files, id)
        .then(data => {
          setIsUploading("upload files completato");
          setImageUploaded(!imageUploaded);
        })
        .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    }

    navigate(0);

  };


  const [age, setAge] = React.useState('');

  const handleSelectStyle = (event) => {
    setAge(event.target.value);
  };

  const [role, setRole] = useState("");

  const handleSelectSiteStyle = (event) => {
    setSiteStyle(event.target.value);
  };

  const handleSelectIsServiceActive = (event) => {
    setIsServiceActive(event.target.value);
  };

  const handleSelectIsShopActive = (event) => {
    setIsShopActive(event.target.value);
  };

  const handleSelectIsIconLoginActive = (event) => {
    setIsIconLoginActive(event.target.value);
  };

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_CONFIGS}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{
              flexDirection: { xs: "row", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Configura</b>&nbsp;
            </Typography>

          </Stack>

          <Stack
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 0, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <Box
              useFlexGap
              sx={{
                paddingTop: 2,
                borderBottom: 1,
                borderColor: 'divider',
                flexWrap: 'wrap'
              }}
            >

              <Tabs
                size={{ xs: 12, md: 12 }}
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="fullWidth"
                centered
                sx={{
                  background: '#b5cdd4',
                }}
              >
                <Tab label="Home" {...a11yProps(0)} />
                <Tab label="Staff" {...a11yProps(1)} />
                <Tab label="Area competenza" {...a11yProps(2)} />
                <Tab label="Chi siamo" {...a11yProps(3)} />
                <Tab label="Contatti" {...a11yProps(4)} />
                <Tab label="Login" {...a11yProps(5)} />
                <Tab label="Account" {...a11yProps(6)} />
                <Tab label="Impostazioni" {...a11yProps(7)} />
                <Tab label="Setup" {...a11yProps(8)} />
              </Tabs>

              <Box
                useFlexGap
                width={{ md: '160ch' }}
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  flexWrap: 'wrap',
                  background: '#e2edf0'
                }}
              >

                {/* ------------------------ tab 1 ---------------------- */}
                {/*  modifica HOME                             index 0    */}

                <CustomTabPanel value={value} index={0}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                      >

                        <TextField id="id-title" label="titolo" variant="outlined" value={title}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTitle(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="sottotitolo" variant="outlined" value={subTitle}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setSubTitle(event.target.value);
                          }}
                        />

                      </Stack>

                      <TextField id="id-description" label="descrizione" variant="outlined" defaultValue={description} value={description}
                        sx={{
                          width: "100ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                        }}
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                        multiline
                        rows={5}
                        maxRows={10}
                      />

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button
                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}
                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>

                {/* ------------------------ tab 2 ---------------------- */}
                {/*  modifica STAFF                            index 1    */}

                <CustomTabPanel value={value} index={1}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                      >

                        <TextField id="id-title" label="titolo" variant="outlined" value={title}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTitle(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="sottotitolo" variant="outlined" value={subTitle}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setSubTitle(event.target.value);
                          }}
                        />

                      </Stack>

                      <TextField id="id-description" label="descrizione" variant="outlined" defaultValue={description} value={description}
                        sx={{
                          width: "100ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                        }}
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                        multiline
                        rows={5}
                        maxRows={10}
                      />
                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>

                {/* ------------------------ tab 3 ---------------------- */}
                {/*  modifica AREE COMP                        index 2    */}

                <CustomTabPanel value={value} index={2}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                      >

                        <TextField id="id-title" label="titolo" variant="outlined" value={title}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTitle(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="sottotitolo" variant="outlined" value={subTitle}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setSubTitle(event.target.value);
                          }}
                        />

                      </Stack>

                      <TextField id="id-description" label="descrizione" variant="outlined" defaultValue={description} value={description}
                        sx={{
                          width: "100ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                        }}
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                        multiline
                        rows={5}
                        maxRows={10}
                      />

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>

                {/* ------------------------ tab 4 ---------------------- */}
                {/*  modifica CHI SIAMO                        index 3    */}

                <CustomTabPanel value={value} index={3}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                      >

                        <TextField id="id-title" label="titolo" variant="outlined" value={title}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTitle(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="sottotitolo" variant="outlined" value={subTitle}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setSubTitle(event.target.value);
                          }}
                        />

                      </Stack>

                      <TextField id="id-description" label="descrizione" variant="outlined" defaultValue={description} value={description}
                        sx={{
                          width: "100ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                        }}
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                        multiline
                        rows={5}
                        maxRows={10}
                      />

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>

                {/* ------------------------ tab 5 ---------------------- */}
                {/*  modifica CONTATTI                         index 4    */}

                <CustomTabPanel value={value} index={4}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                      >

                        <TextField id="id-title" label="titolo" variant="outlined" value={title}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTitle(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="sottotitolo" variant="outlined" value={subTitle}
                          sx={{
                            width: "50ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setSubTitle(event.target.value);
                          }}
                        />

                      </Stack>

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>


                {/* ------------------------ tab 6 ---------------------- */}
                {/*  modifica LOGIN                            index 5    */}

                <CustomTabPanel value={value} index={5}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>


                {/* ------------------------ tab 7 ---------------------- */}
                {/*  modifica ACCOUNT                          index 6    */}

                <CustomTabPanel value={value} index={6}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        }}
                      >

                        <Stack
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            display: 'flex',
                            flexDirection: { xs: "row", md: "row" },
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="small"
                            component="label"
                            fullWidth
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                            }}
                          >
                            Carica immagine
                            <input type="file" onChange={handleLoadImage} hidden multiple />
                          </Button>

                          <Typography variant="h6" color="navy"
                            sx={{
                              width: "20ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            {pageImageItems.length} immagini caricate
                          </Typography>

                          <Typography variant="h9" color="black"
                            sx={{
                              width: "50ch",
                              p: 1,
                              m: 1,
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                            }}
                          >
                            puoi modificare titoli e info
                          </Typography>

                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: { xs: "row", md: "row" },
                            paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                            position: "center", overflowX: "scroll", maxWidth: "100%",
                          }}
                        >

                          {pageImageItems.map((image, idx) => (

                            <AdminConfigsElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={page} />

                          ))}

                        </Stack>

                      </Box>

                    </Paper>

                  </Box>

                </CustomTabPanel>


                {/* ------------------------ tab 8 ---------------------- */}
                {/*  modifica IMPOSTAZIONI                     index 7    */}

                <CustomTabPanel value={value} index={7}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        useFlexGap
                        sx={{
                          flexDirection: { xs: "column", md: "row" },
                          paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                          flexWrap: 'wrap'
                        }}
                      >

                        <TextField id="id-title" label="ragione sociale" variant="outlined" value={ragioneSociale}
                          sx={{
                            width: "40ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setRagioneSociale(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="cliente" variant="outlined" value={cliente}
                          sx={{
                            width: "40ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setCliente(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="partita iva" variant="outlined" value={partitaIva}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setPartitaIva(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="indirizzo" variant="outlined" value={indirizzo}
                          sx={{
                            width: "30ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setIndirizzo(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="cap" variant="outlined" value={cap}
                          sx={{
                            width: "10ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setCap(event.target.value);
                          }}
                        />
                        <TextField id="id-subtitle" label="città" variant="outlined" value={citta}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setCitta(event.target.value);
                          }}
                        />
                        <TextField id="id-subtitle" label="provincia" variant="outlined" value={provincia}
                          sx={{
                            width: "20h",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setProvincia(event.target.value);
                          }}
                        />
                        <TextField id="id-subtitle" label="telefono" variant="outlined" value={telefono}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTelefono(event.target.value);
                          }}
                        />
                        <TextField id="id-subtitle" label="telefono 1" variant="outlined" value={telefono1}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setTelefono1(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="mobile" variant="outlined" value={mobile}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setMobile(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="mobile 1" variant="outlined" value={mobile1}
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setMobile1(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="email" variant="outlined" value={email}
                          sx={{
                            width: "40ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setEmail(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="email 1" variant="outlined" value={email1}
                          sx={{
                            width: "40ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setEmail1(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="aliquota iva" variant="outlined" type="number" value={aliquotaIva}
                          sx={{
                            width: "10ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setAliquotaIva(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="aliquota iva ridotta" variant="outlined" type="number" value={aliquotaIvaRid}
                          sx={{
                            width: "10ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setAliquotaIvaRid(event.target.value);
                          }}
                        />

                        <TextField id="id-subtitle" label="aliquota iva minima" variant="outlined" type="number" value={aliquotaIvaMin}
                          sx={{
                            width: "10ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                          onChange={(event) => {
                            setAliquotaIvaMin(event.target.value);
                          }}
                        />

                      </Stack>

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          disabled="true"

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                  </Box>

                </CustomTabPanel>

                {/* ------------------------ tab 9 ---------------------- */}
                {/*  modifica SETUP                            index 8    */}

                <CustomTabPanel value={value} index={8}>

                  <Box
                    sx={{ flexDirection: { xs: "column", md: "column" } }}
                  >

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        height: 30
                      }}
                    />

                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'

                      }}
                      elevation={6}
                    >

                      <Stack
                        useFlexGap
                        sx={{
                          flexDirection: { xs: "column", md: "row" },
                          paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                          flexWrap: 'wrap'
                        }}
                      >

                        <FormControl
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                        >
                          <InputLabel id="style-select-label">
                            stile del sito
                          </InputLabel >
                          <Select
                            labelId="style-select-label"
                            id="style-select-label"
                            value={siteStyle}
                            label="Ruolo"
                            onChange={handleSelectSiteStyle}
                          >
                            <MenuItem value="Classic">Classic</MenuItem>
                            <MenuItem value="Jazz">Jazz</MenuItem>
                            <MenuItem value="Modern">Modern</MenuItem>
                            <MenuItem value="Time">Time</MenuItem>
                          </Select>
                        </FormControl>

                        <FormControl
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                        >
                          <InputLabel id="style-select-label">
                            servizi
                          </InputLabel >
                          <Select
                            labelId="style-select-label"
                            id="style-select-label"
                            value={isServiceActive}
                            label="Servizi"
                            onChange={handleSelectIsServiceActive}
                          >
                            <MenuItem value="Si">Si</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>

                        <FormControl
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                        >
                          <InputLabel id="style-select-label">
                            shop/prodotti
                          </InputLabel >
                          <Select
                            labelId="style-select-label"
                            id="style-select-label"
                            value={isShopActive}
                            label="Ruolo"
                            onChange={handleSelectIsShopActive}
                          >
                            <MenuItem value="Si">Si</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>

                        <FormControl
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                        >
                          <InputLabel id="style-select-label">
                            icona login
                          </InputLabel >
                          <Select
                            labelId="style-select-label"
                            id="style-select-label"
                            value={isIconLoginActive}
                            label="Ruolo"
                            onChange={handleSelectIsIconLoginActive}
                          >
                            <MenuItem value="Si">Si</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>

                        <FormControl
                          sx={{
                            width: "30ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                          }}
                        >
                          <InputLabel id="style-select-label">
                            voci menù
                          </InputLabel >
                          <Select
                            labelId="style-select-label"
                            id="style-select-label"
                            value={role}
                            label="Ruolo"
                            onChange={handleSelectStyle}
                          >
                            <MenuItem value="Servizi">Servizi</MenuItem>
                            <MenuItem value="Staff">Staff</MenuItem>
                            <MenuItem value="Area competenza">Area competenza</MenuItem>
                            <MenuItem value="Chi siamo">Chi siamo</MenuItem>
                            <MenuItem value="Contatti">Contatti</MenuItem>
                          </Select>
                        </FormControl>

                      </Stack>

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button

                          disabled="true"

                          variant="contained"
                          type="submit"
                          color="success"
                          onClick={handleSalva}
                          sx={{
                            width: "12ch",
                            p: 1,
                            m: 1,
                          }}

                        >
                          Salva
                        </Button>

                      </Stack>

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 20
                        }}
                      />

                    </Paper>

                  </Box>

                </CustomTabPanel>

              </Box>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 50
                }}
              />

            </Box>

          </Stack>
        </Box>

      </Grid>
    </Box>


  );
};

export default AdminConfigsPageComponent;
